import { Fragment, useEffect, useState } from "react";
import "./Footer.scss";
import { icons } from "../../utils/icons";
import { FaLinkedinIn } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";
import axios from "axios";
import { baseUrl, emailSubscription } from "../../utils/apiData";
import Logo from "../../assets/images/logo.png";

import { NavLink } from "react-router-dom";

const Footer = () => {
  const [viewMsg, setViewMsg] = useState(false);
  const [loader, setLoader] = useState(false);

  const emailSubmitApi = async ({ emailId }) => {
    setLoader(true);
    try {
      const res = await axios.post(`${baseUrl}/${emailSubscription}`, {
        email: emailId,
      });
      if (res?.data?.success) {
        setViewMsg(true);
        setLoader(false);
        setEmail("");
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  let emailAddress = "info@lorem.com";

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const inpoutHandler = (e) => {
    setEmail(e.target.value);
    validation(e.target.value);
  };

  const blurMailHandler = (e) => {
    validation(e.target.value);
  };

  const validation = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!value.trim()) {
      setError("This Field is Required!");
    } else if (!emailRegex.test(value)) {
      setError("Please Enter Valid Email Formate!");
    } else {
      setError("");
    }
  };

  const submitEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email.trim()) {
      setError("This Field is Required!");
    } else if (!emailRegex.test(email)) {
      setError("Please Enter Valid Email Formate!");
    } else {
      setError("");
      emailSubmitApi(email);
    }
  };

  return (
    <Fragment>
      <footer>
        <section className="footer">
          <div className="content_wrap">
            <div className="title_grid">
              <h3 className="wow fadeInUp">
                Stay ahead with Farsight Technology—subscribe now and explore
                the future of innovation!
              </h3>
              <div className="mail_wrap">
                {viewMsg ? (
                  <div className="msf_wrap">
                    <h3>Mail sent successfully!</h3>
                  </div>
                ) : (
                  <Fragment>
                    {loader ? (
                      <p>Loading...</p>
                    ) : (
                      <div className="mail_field">
                        <div className="input_wraper">
                          <input
                            type="email"
                            name="email"
                            placeholder="Enter Your Email"
                            value={email}
                            onChange={inpoutHandler}
                            onBlur={blurMailHandler}
                            autoComplete="off"
                          />
                          <button
                            type="button"
                            className="icon_btn"
                            onClick={submitEmail}
                            disabled={error}
                          >
                            <img src={icons.urwhitearrow} alt="arrow" />
                          </button>
                        </div>
                        {error && <p className="t-12 error">{error}</p>}
                      </div>
                    )}
                  </Fragment>
                )}
              </div>
            </div>
            <div className="links_grid">
              <div className="link_col">
                <img src={Logo} className="logo" alt="Brand Logo" />
                <div className="social_wrap">
                  <a
                    href="https://www.linkedin.com/company/farsight-secure-seamless-strategic/?viewAsMember=true"
                    target="_blank"
                  >
                    <FaLinkedinIn />
                  </a>
                  <a href="https://x.com/BohsecPCS" target="_blank">
                    <BsTwitterX />
                  </a>
                </div>
              </div>
              <div className="link_col">
                <p className="t-16">Useful Links</p>
                <NavLink to="/">Home</NavLink>
                {/* <NavLink to="/solutions">Solutions</NavLink> */}
                <NavLink to="/vendors">Vendors</NavLink>
                {/* <NavLink to="/services">Services</NavLink> */}
                <NavLink to="/blog">Blogs</NavLink>
                <NavLink to="/contactus">Contact</NavLink>
              </div>

              <div className="link_col">
                <p className="t-16">Company</p>
                <NavLink to="/about">About</NavLink>
                <NavLink to="/events">Events</NavLink>
                <NavLink to="/partnerwithus">Partner with us</NavLink>
              </div>

              {/* <div className="link_col">
                <p className="t-16">Legal</p>
                <NavLink to="/terms_of_services">Terms & Conditions</NavLink>
                <NavLink to="/privacy_policy">Privacy Policy</NavLink>
              </div> */}
            </div>

            <div className="copy_rights">
              <p className="t-16">
                © {new Date().getFullYear()} Farsight. All rights reserved.
                Designed and Developed by{" "}
                <a href="https://supagrow.in/" target="_blank">
                  Supagrow.
                </a>
              </p>
            </div>
          </div>
        </section>
      </footer>
    </Fragment>
  );
};

export default Footer;
